export function isEbvField(field: string): boolean {
  return /^ebv\d+$/i.test(field);
}

export function isEbvAccuracyField(field: string): boolean {
  return /^ebv\d+Acc$/i.test(field);
}

export function isEbvPercentileField(field: string): boolean {
  return /^ebv\d+Percentile$/i.test(field);
}

export function isAnyEbvField(field: string): boolean {
  return (
    isEbvField(field) ||
    isEbvAccuracyField(field) ||
    isEbvPercentileField(field)
  );
}
